import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SocketService } from '../../services/socket.service';



@Component({
	selector: 'app-ranking',
	templateUrl: './ranking.component.html',
	styleUrls: ['./ranking.component.scss']
})


export class RankingComponent implements OnInit {
	public showScoreboard = false;
	public dataLoaded: boolean = false;
	public data = { allData: null, newData: []};
	private rankingChangeSubscriber: Subscription;
	public lastAdded;

	private interval;
	private timeout;
	//------------------------------------------------------------------- CONSTRUCTOR
	constructor(
		private socketService: SocketService,
	) { }

	//------------------------------------------------------------------- INIT
	ngOnInit() {
		this.socketService.initialize();
		this.socketService.showRanking(true);

		this.rankingChangeSubscriber = this.socketService.onRankingUpdate().subscribe((data)=>{
			this.showScoreboard = true;
			console.log('Change - ',data);
			this.data.allData = data.allData;
			//new data => array
			if(data.newData) this.data.newData.push(data.newData);

			//show last added
			if(this.data.newData.length ==1){
				this.showLastAdded();
			}

			if(this.interval) clearInterval(this.interval)

			// loop every
			this.interval = setInterval(()=>{
				this.data.newData.shift()
				this.showLastAdded();
			}, 5 * 1000)

			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				this.showScoreboard = false;
			}, 10 * 1000);
		})
	}

	showLastAdded(){
		this.lastAdded = this.data.newData[0];
	}

	//------------------------------------------------------------------- DESTROY
	ngOnDestroy() {
		if(this.interval) clearInterval(this.interval)
		if(this.rankingChangeSubscriber) this.rankingChangeSubscriber.unsubscribe();
	}

}



// WEBPACK FOOTER //
// /app/src/app/views/ranking/ranking.component.ts